import React from 'react';
import ImportWizardPage from './ImportWizardPage';
import MapMandatoryFieldsStep from '../components/asset/MapMandatoryFieldsStep';
import MapAdditionalFieldsStep from '../components/asset/MapAdditionalFieldsStep';
import PreviewStep from '../components/asset/PreviewStep';
import SubmitModal from '../components/asset/SubmitModal';
import SuccessModal from '../components/asset/SuccessModal';

const initialTargetDropdownSelections: Record<string, string> = {
  asset_tag: 'asset_tag',
};

const NewDataAssetImportPage: React.FC = () => (
  <ImportWizardPage
    title="New Data Asset Import"
    entityLabelPlural="assets"
    listPath="/assets/list"
    initialTargetDropdownSelections={initialTargetDropdownSelections}
    uniqueFieldKey="asset_tag"
    MapMandatoryFieldsStep={MapMandatoryFieldsStep}
    MapAdditionalFieldsStep={MapAdditionalFieldsStep}
    PreviewStep={PreviewStep}
    SubmitModal={SubmitModal}
    SuccessModal={SuccessModal}
  />
);

export default React.memo(NewDataAssetImportPage);
